const tr = {
    planBilling:{
      attributes:{
        user_id:            'Usuário ID',
        user_name:          'Usuário',
        plan_name:          'Plano',
        transaction_at:     'Data da Transação',
        validity_at:        'Data de Validade',
        price:              'Preço',
        transaction_id:     'ID da Transação',
        store:              'Loja',
        state:              'Status',
        origin:             'Origem',
        check_status:       'Verificar Status',
      },
      extras:{
        transactions: 'Transações',
        transaction_data: 'Dados da Transação',
        loading: 'Carregando...',
        active_store: 'Ativo na loja',
        state_store: 'Status da loja',
        validity_store: 'Validade da loja',
        show_billing: 'Visualizando compra',
      },
      defSingular: 'Dados da Compra',
      defPlural: 'Compras de assinaturas',
    }
  };
  
  export default tr;
  